export default "__VITE_ASSET__Dj$kJX2e__"